module.exports = "../dist/img/product-detail-2-18.99d9.jpg";